var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon10ReserveStats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "0_\\uC608\\uC57D\\uAD00\\uB9AC",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2-1-1_\\uC608\\uC57D\\uD604\\uD669_default",
    transform: "translate(-26.000000, -204.000000)",
    fill: "#46B476"
  }, /*#__PURE__*/React.createElement("g", {
    id: "side",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(6.000000, 203.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon01",
    transform: "translate(19.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.49330403,16.7016129 C5.52598145,16.7016129 2.29835645,13.4739879 2.29835645,9.50666532 C2.29835645,5.53941935 5.52598145,2.31187097 9.49330403,2.31187097 C13.46055,2.31187097 16.688175,5.53941935 16.688175,9.50666532 C16.688175,13.4739879 13.46055,16.7016129 9.49330403,16.7016129 M9.49330403,0.013483871 C4.25865081,0.013483871 -3.06451612e-05,4.27208871 -3.06451612e-05,9.50666532 C-3.06451612e-05,14.7413185 4.25865081,19 9.49330403,19 C14.7278806,19 18.9865621,14.7413185 18.9865621,9.50666532 C18.9865621,4.27208871 14.7278806,0.013483871 9.49330403,0.013483871",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.52842921,16.9623893 L9.52842921,10.3838788 C9.52842921,9.7540206 9.01695954,9.2433823 8.38590576,9.2433823 C7.75492814,9.2433823 7.2433823,9.7540206 7.2433823,10.3838788 L7.2433823,18.1028858 C7.2433823,18.732744 7.75492814,19.2433823 8.38590576,19.2433823 L16.1008588,19.2433823 C16.7318365,19.2433823 17.2433823,18.732744 17.2433823,18.1028858 C17.2433823,17.4730276 16.7318365,16.9623893 16.1008588,16.9623893 L9.52842921,16.9623893 Z",
    id: "Fill-4",
    transform: "translate(12.243382, 14.243382) scale(1, -1) rotate(-17.000000) translate(-12.243382, -14.243382) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7850469,9.3595035 L10.7850469,1.6404965 C10.7850469,1.0106383 10.2735772,0.5 9.64252345,0.5 C9.01154583,0.5 8.5,1.0106383 8.5,1.6404965 L8.5,9.3595035 C8.5,9.9893617 9.01154583,10.5 9.64252345,10.5 C10.2735011,10.5 10.7850469,10 10.7850469,9.3595035 Z",
    id: "Fill-4",
    transform: "translate(9.642523, 5.500000) scale(1, -1) translate(-9.642523, -5.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9570625,10.6193091 L13.9570625,3.67220279 C13.9570625,3.10533041 13.4455928,2.64575594 12.814539,2.64575594 C12.1835614,2.64575594 11.6720156,3.10533041 11.6720156,3.67220279 L11.6720156,10.6193091 C11.6720156,11.1861815 12.1835614,11.6457559 12.814539,11.6457559 C13.4455166,11.6457559 13.9570625,11.1957559 13.9570625,10.6193091 Z",
    id: "Fill-4",
    transform: "translate(12.814539, 7.145756) scale(1, -1) rotate(-41.000000) translate(-12.814539, -7.145756) "
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon10ReserveStats);
export default __webpack_public_path__ + "static/media/icon10_reserveStats.add3c66afd6aa1070b17f3578317d69c.svg";
export { ForwardRef as ReactComponent };